// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"7afeed81","239":"c8bb4f0b","453":"ff29e211","455":"b5b6d421"}[chunkId] + ".chunk.js";
};